import clsx from "clsx";

import type { Icon } from "@phosphor-icons/react";

interface UpsellCardProps {
  id: string;
  title: string;
  icon: Icon;
}

export default function UpsellCard({ title, icon }: UpsellCardProps) {
  const Icon = icon;

  return (
    <div className="flex flex-col gap-5.75 bg-whiteGray border border-black-200 pt-3 pr-3 pb-4 pl-5 rounded-4xl">
      <div className="ml-auto p-2 bg-purple-100/25 rounded-2xl">
        <Icon className="size-4 text-purple-300" />
      </div>

      <span
        className={clsx([
          "text-button-xs",
          title.length > 21 ? "max-w-33" : "max-w-26",
        ])}
      >
        {title}
      </span>
    </div>
  );
}
